export default __webpack_public_path__ + "static/media/website_under_construction_4.d8cb576f.png";